import script from "./shipment-list.vue?vue&type=script&setup=true&lang=js"
export * from "./shipment-list.vue?vue&type=script&setup=true&lang=js"

import "./shipment-list.vue?vue&type=style&index=0&id=734e30f0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734e30f0"]])

export default __exports__